import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

// Helper: ISO country code → 🇺🇸 flag
const isoToFlag = (iso) =>
  iso
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt())) +
  "\uFE0F"; // FORCE emoji rendering

// Helper: ISO → country name (browser standard)
const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

// Get ALL supported regions from libphonenumber
const regions = phoneUtil.getSupportedRegions();

/**
 * FINAL countries list
 * [
 *   {
 *     iso: "US",
 *     name: "United States",
 *     dialCode: "+1",
 *     flag: "🇺🇸"
 *   }
 * ]
 */
const countries = Array.from(regions)
  .map((iso) => {
    const code = phoneUtil.getCountryCodeForRegion(iso);
    if (!code) return null;

    return {
      iso,
      name: regionNames.of(iso) || iso,
      dialCode: `+${code}`,
      flag: isoToFlag(iso),
      flagSvg: `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${iso
        .toUpperCase()
        .split("")
        .map((c) => (c.charCodeAt(0) - 65 + 0x1f1e6).toString(16))
        .join("-")}.svg`,
    };
  })
  .filter(Boolean)
  .sort((a, b) => a.name.localeCompare(b.name));

export default countries;
